export default __webpack_public_path__ + "static/media/playup-bonus-cash.4fb53837.svg";